<template>
  <v-list-item
    :to="{
      name: 'EmployeeDetails',
      params: { shorthand: item.shorthand }
    }"
    @click="$emit('click')"
  >
    <v-list-item-content>
      <v-list-item-title
        >{{ item.firstName }} {{ item.lastName }}</v-list-item-title
      >
      <v-list-item-subtitle>
        {{ $t('employeeDetails.shorthand') }}:
        {{ item.shorthand }}

        <span class="px-2">&ndash;</span>

        {{ $t('employeeDetails.supervisor') }}:
        {{ item.supervisorName }}
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>
